import slugify from 'slugify';

export function getRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function toSlug(text: string) {
  return slugify(text)
    .toLowerCase()
    .replace(/[^\w-]+/g, '');
}

// todo add fakeNow=${nowTime} ???
export const getIframeTemplate = (url: string) => {
  return `<iframe class="iframe" src="${url}"
    scrolling="no" width="100%" height="100%" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" allow="autoplay" />`;
};

export const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
